import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { UserService } from '../../auth/user.service';
import { NavigationService } from './navigation.service';
import { NavigationServiceOpen } from '../navigation-open/navigation.service';
import { UserInfo } from 'app/auth/user';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'ma-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  user: UserInfo;
  public bgMenu: boolean;
  public show: boolean;
  public close: boolean;
  public loggedIn: boolean;
  constructor(
    public auth: AuthService,
    private router: Router,
    private navigationServiceOpen: NavigationServiceOpen,
    private userService: UserService,
    private navigationService: NavigationService) {
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.refreshUserState();

    // Re-evaluate auth/user state after redirect-based logins.
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.refreshUserState());
  }

  private refreshUserState(): void {
    this.userService.getUserInfo().then(user => {
      this.user = user;
      this.loggedIn = this.user != null && this.user.id != null;
    });
  }

  menuToggle() {
    this.show = !this.show;
    this.close = !this.close;
    this.bgMenu = !this.bgMenu;
  }
  toggleHamburgerMenu(): void {
    this.navigationServiceOpen.toggleHamburgerMenu();
  }
  hideHamburgerMenu(): void {
    this.navigationServiceOpen.hideHamburgerMenu();
  }
  logoutUser() {
    this.userService.clearUserCache();
    this.loggedIn = false;
    this.user = new UserInfo;
    this.auth.logout();
  }
}